import UltMeta, { Meta } from "./UltMeta/index";


/**
 * 资金类型
 */
class Funds extends UltMeta {
    PROCUREMENT_LOAN = new Meta(1, "砂石骨料采购");
    EQUIPMENT_PROCUREMENT = new Meta(2, "采区开大户");
    OTHERS = new Meta(3, "其他");
}

export const FUNDING_CLUES_TYPE = new Funds();


/**
 * 状态
 */
class State extends UltMeta {
    PENDING_PROCESSING = new Meta(1, "待处理");
    PROCESSING = new Meta(2, "处理中");
    PROCESSED = new Meta(3, "已处理");
}

export const FUNDING_CLUES_STATE = new State();

/**
 * 线索来源
 */
class CluesSource extends UltMeta {
    ONE = new Meta(1, "链云砂石");
    TWO = new Meta(2, "链云船务");
    THREE = new Meta(3, "白露说砂石");
    FOUR = new Meta(4, "建邺");
}

export const CLUES_SOURCE = new CluesSource();


